import { CALL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';
const Call = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: CALL_TYPE_ID,
  referenceObjectType: 'CALL_PROPERTIES'
});
export default Call;